import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { Config } from 'hb-builder/types';

const BuilderConfigContext = createContext<Config | undefined>(undefined);

export const BuilderConfigProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: Config }>) => {
  const value = useMemo(() => config, [config]);

  return (
    <BuilderConfigContext.Provider value={value}>
      {children}
    </BuilderConfigContext.Provider>
  );
};

export const useBuilderConfigContext = () => {
  const context = useContext(BuilderConfigContext);

  if (!context) {
    throw new Error(
      'useBuilderConfigContext must be used within a BuilderConfigProvider',
    );
  }

  return context;
};
